export default __webpack_public_path__ + "static/media/Glodani 12.e2493953.jpg";